import { render, staticRenderFns } from "./CreateKokuban.vue?vue&type=template&id=6c5f002a&scoped=true&"
import script from "./CreateKokuban.vue?vue&type=script&lang=js&"
export * from "./CreateKokuban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f002a",
  null
  
)

export default component.exports